import * as React from 'react';
import { selectContrastingColor } from '../../utils/selectContrastingColor';
import { setColorWithOpacityCss } from '../../utils/setColorWithOpacityCss';
import { StyledLinkButton } from './LinkButton.styled';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `LinkButton` content block allows the user to place a simple `href` button. At the
 * moment, only plain text is allowed for the button's label.
 */
export const LinkButton = ({
  alignXPreset,
  cssBackgroundColor,
  cssBackgroundColorOpacity,
  cssBorderRadius,
  cssBorderColor,
  cssBorderWidth,
  cssColor,
  content = 'Link Button',
  href = '',
  openLinkInNewTab = false,
  parentLayoutInfo,
  ...rest
}) => /*#__PURE__*/_jsx(StyledContentContainer, {
  parentLayoutInfo: parentLayoutInfo,
  children: /*#__PURE__*/_jsx(StyledLinkButton, {
    "data-id": "cp-link-button",
    alignXPreset: alignXPreset,
    cssBackgroundColor: setColorWithOpacityCss(cssBackgroundColor, cssBackgroundColorOpacity),
    cssColor: cssColor || selectContrastingColor(cssBackgroundColor, {
      fallbackCssVar: '--computed-color__theme-color__background--contrast'
    }),
    cssBorderRadius: cssBorderRadius,
    cssBorderWidth: cssBorderWidth,
    cssBorderColor: cssBorderColor,
    href: href,
    target: openLinkInNewTab ? '_blank' : undefined,
    ...rest,
    children: content
  })
});